/**
 * Search Drawer — oddit-search-drawer
 * Handles open/close, overlay dismiss, clear button, escape key, and cancel button.
 * Supports Shopify theme editor section lifecycle events.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-search-drawer';
  var ACTIVE_CLASS = 'oddit-search-drawer--active';

  function randomizePopularProducts(section) {
    if (!section) return;

    var popularSection = section.querySelector(
      '[data-random-popular-products]'
    );

    if (!popularSection) return;

    var products = Array.prototype.slice.call(
      popularSection.querySelectorAll(
        '[data-random-popular-product]'
      )
    );

    if (!products.length) return;

    /*
     * Hide all products in case the function runs again.
     */
    products.forEach(function (product) {
      product.hidden = true;
    });

    /*
     * Shuffle the eligible Best Sellers products.
     */
    for (var i = products.length - 1; i > 0; i--) {
      var randomIndex = Math.floor(Math.random() * (i + 1));
      var temporaryProduct = products[i];

      products[i] = products[randomIndex];
      products[randomIndex] = temporaryProduct;
    }

    /*
     * Reveal four randomly selected products.
     */
    products.slice(0, 4).forEach(function (product) {
      product.hidden = false;
    });
  }


  function initSearchDrawer(container) {
    var section = container || document.querySelector(SECTION_SELECTOR);
    if (!section) return null;

      randomizePopularProducts(section);

    var overlay = section.querySelector('.oddit-search-drawer__overlay');
    var input = section.querySelector('.oddit-search-drawer__input');
    var clearBtn = section.querySelector('.oddit-search-drawer__clear-btn');
    var cancelBtn = section.querySelector('.oddit-search-drawer__cancel-btn');
    var previouslyFocusedElement = null;

    function closeDrawer(options) {
      options = options || {};
      var restoreFocus = options.restoreFocus !== false;

      section.classList.remove(ACTIVE_CLASS);
      section.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      if (restoreFocus && previouslyFocusedElement && document.contains(previouslyFocusedElement)) {
        /*
         * Keyboard/cancel dismissal returns focus to the control that opened
         * Search. Suppress the header input's focus-to-open handler during
         * this one programmatic restoration so the drawer does not reopen.
         */
        window.odditSearchDrawerRestoringFocus = true;
        previouslyFocusedElement.focus();
        window.setTimeout(function () {
          window.odditSearchDrawerRestoringFocus = false;
        }, 0);
      } else if (!restoreFocus) {
        /*
         * A pointer click on the backdrop is an intentional click-away.
         * Do not leave either the drawer input or desktop header search input
         * focused, otherwise a blinking caret remains after the drawer closes.
         */
        var activeElement = document.activeElement;
        if (activeElement && typeof activeElement.blur === 'function') {
          activeElement.blur();
        }
      }

      previouslyFocusedElement = null;
    }

    function openDrawer() {
      previouslyFocusedElement = document.activeElement;
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = scrollbarWidth + 'px';
      section.classList.add(ACTIVE_CLASS);
      section.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input) {
        input.focus();
      }
    }

    function handleKeydown(e) {
      if (!section.classList.contains(ACTIVE_CLASS)) return;
      if (e.key === 'Escape') {
        closeDrawer();
      } else if (e.key === 'Tab') {
        var panel = section.querySelector('.oddit-search-drawer__panel');
        var focusable = panel ? panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])') : [];
        if (focusable.length) {
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      } else if (e.key === 'Enter' && input && input.value.trim()) {
        window.location.href = window.theme.routes.searchUrl + '?q=' + encodeURIComponent(input.value.trim());
      }
    }

    // Clear button — clears the input text
    if (clearBtn && input) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
      });
    }

    // Cancel button — closes the drawer
    if (cancelBtn) {
      cancelBtn.addEventListener('click', closeDrawer);
    }

    // Overlay click — closes the drawer (desktop)
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeDrawer({ restoreFocus: false });
      });
    }

    // Escape key — closes the drawer
    document.addEventListener('keydown', handleKeydown);

    // Expose open/close methods globally for external triggers
    window.odditSearchDrawer = {
      open: openDrawer,
      close: closeDrawer
    };

    // Return teardown function for cleanup
    return {
      open: openDrawer,
      close: closeDrawer,
      destroy: function () {
        document.removeEventListener('keydown', handleKeydown);
        if (clearBtn && input) {
          clearBtn.replaceWith(clearBtn.cloneNode(true));
        }
        if (cancelBtn) {
          cancelBtn.replaceWith(cancelBtn.cloneNode(true));
        }
        if (overlay) {
          overlay.replaceWith(overlay.cloneNode(true));
        }
        delete window.odditSearchDrawer;
      }
    };
  }

  // Initial setup
  var instance = initSearchDrawer();

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector(SECTION_SELECTOR)) {
      instance = initSearchDrawer(e.target.querySelector(SECTION_SELECTOR));
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector(SECTION_SELECTOR) && instance) {
      instance.destroy();
      instance = null;
    }
  });
})();